
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { InputNumber, Modal } from 'ant-design-vue';

@Component({
    name: 'MultiplierModal',
    components: { Modal, InputNumber },
})
export default class MultiplierModal extends Vue {
    @Prop({ default: 1 }) private timesToMultiply!: number;
    @Prop({ default: false }) private isMultiplierModalVisible!: boolean;

    private closeMultiplierPopup() {
        this.$emit('update:isMultiplierModalVisible', false);
    }

    @Watch('isMultiplierModalVisible')
    private async onModalOpen() {
        if (!this.isMultiplierModalVisible) {
            return;
        }

        this.$emit('update:timesToMultiply', 1);

        await this.$nextTick();
        if (this.$refs.timesToMultiply) {
            // @ts-ignore
            const inputContainer = this.$refs.timesToMultiply.$el as HTMLElement;

            if (inputContainer) {
                const inputEl = inputContainer.querySelector('input');
                if (inputEl) {
                    inputEl.focus();
                    inputEl.select(); // Selects the entire text
                }
            }
        }
    }
}
